export const INTERIM_DIALOG_TITLE_ATTR = {
  name: 'data-component-name',
  value: 'interim_dialog_title'
};
export const AttrProps = { [INTERIM_DIALOG_TITLE_ATTR.name]: INTERIM_DIALOG_TITLE_ATTR.value };
